import Vue from 'vue'
import Vuex from 'vuex'
import wedrive from './modules/wedrive' 
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    wedrive
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})